import { Component, OnInit } from '@angular/core';
import { CommonService } from '@app/helpers/common.service';

@Component({
  selector: 'app-s-rodo',
  templateUrl: './s-rodo.component.html',
  styleUrls: ['./s-rodo.component.scss'],
})
export class SRodoComponent implements OnInit {
  providerInfo: any;

  constructor(private commonService: CommonService) {}

  ngOnInit(): void {
    this.getData();
  }

  async getData() {
    try {
      this.commonService.onLoaderChange.next(true);
      this.providerInfo = await this.commonService.getHtmlTemplate({ route: 'service_provider_gdpr_detail' });
      this.commonService.onLoaderChange.next(false);
    } catch (error) {
      console.error(error);
      this.commonService.onLoaderChange.next(false);
    }
  }
}
